import { useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import { FooterGlobalStyle } from '../GlobalStyles';
import NotificationGlobalStyle from './notification/NotificationGlobalStyle';
import themeTokens from './themeTokens';

export const PORSCHE_THEME_CLASSNAME = 'theme-porsche';

const GlobalThemeToken = createGlobalStyle`
    html.${PORSCHE_THEME_CLASSNAME} {
        /* For css variables antd override */
        --ant-primary-color: ${themeTokens.primaryColor};
        --ant-primary-color-hover: ${themeTokens.hoveredPrimaryColor};
        --ant-primary-color-active: ${themeTokens.primaryColor};

        /* font sizes */
        --button-font-size: ${themeTokens.buttonFontSize};
        --input-font-size: ${themeTokens.inputFontSize};

        /* input field */
        --input-height: ${themeTokens.inputFieldHeight};
        
        /* checkboxes */
        --checkbox-width: 1.5rem;
        --checkbox-height: 1.5rem;

        --checkbox-inner-border-color: #ffffff;
        --checkbox-inner-background-color: #626669;

        --checkbox-summary-checked-inner-border-color: #323639;
        --checkbox-checked-inner-border-color: #323639;
        --checkbox-summary-checked-inner-background-color: #323639; 
        --checkbox-checked-inner-background-color: #323639; 

        --checkbox-checked-inner-after-border-color: #ffffff;

        /* For configurator pages */
        --configurator-text-color: ${themeTokens.textColor};
        --configurator-border-radius: 0;
        --configurator-divider-color: #00000020;
        --configurator-calculator-pre-summary-border-color: transparent;
        --configurator-calculator-summary-border-color: rgba(0,0,0,0.5);

        --configurator-back-color: ${themeTokens.primaryColor};
        --configurator-back-color-hover: ${themeTokens.hoveredPrimaryColor};
        --configurator-back-color-active: ${themeTokens.primaryColor};

        --configurator-widget-active-color: var(--ant-primary-color);
        --configurator-widget-title-font-weight: 900;
        --configurator-widget-background: #f2f2f2;
        --configurator-widget-text-color: ${themeTokens.textColor};

        --configurator-widget-popup-background: #f2f2f2;
        --configurator-widget-popup-summary-text-color: ${themeTokens.textColor};
        --configurator-widget-popup-text-color: ${themeTokens.textColor};
        --configurator-widget-popup-disabled-text-color: rgb(150, 152, 154);
        --configurator-widget-popup-text-color-opacity: 1;
        --configurator-widget-popup-calculator-background: #00000011;

        --configurator-widget-bar-color: #b5b5b5;
        --configurator-widget-bar-open-color: #b5b5b5;

        --configurator-widget-checked-color: #ffffff;

        --configurator-vehicle-select-height: 88px;
        --configurator-vehicle-select-label-padding-bottom: 8px;
        --configurator-widget-popup-calculator-field-background-color: rgba(0, 0, 0, 0.07);

        --configurator-widget-dealer-select-container-height: auto;
        --configurator-widget-dealer-select-container-form-item-display: flex;

        /* For calculator ui */
        --calculator-form-item-error-border: 1px var(--ant-error-color) solid;

        --calculator-field-background-color: rgba(0, 0, 0, 0.07);
        --calculator-field-label-padding: 0 11px;
        --calculator-field-label-color: rgb(0, 0, 0);
        --calculator-field-disabled-label-color:  rgb(0, 0, 0);
        --calculator-field-padding: 10px 5px;
        --calculator-grid-item-gap: 10px;
        --calculator-grid-item-min-height: min-content;

        --calculator-comparison-form-item-height-default: 57px;
        --calculator-comparison-form-item-height-second: 57px;
        --calculator-comparison-below-condition-background: #f5f5f5;
        --calculator-comparison-form-item-ant-typography-padding-left-right: 11px;
        --calculator-comparison-mobile-form-item-padding-top: 45px;
        --calculator-comparison-mobile-form-item-padding-top-sm: 38px;
        --calculator-comparison-form-item-error-position: absolute;
        --calculator-comparison-vehicle-image-height: 337px;
        --calculator-comparison-vehicle-image-height-xl: 179px;
        --calculator-comparison-vehicle-image-height-lg: 121px;
        --calculator-comparison-vehicle-image-height-m: 180px;
        --calculator-comparison-vehicle-image-height-sm: 225px;

        --vehicle-image-border-radius: 0px;

        --image-selection-border: 0px solid transparent;
        --image-selection-border-radius: 0px;
        --image-selection-active-border-color: transparent;
        --image-selection-outline: 2px solid transparent;
        --image-selection-outline-offset: 3px;
        --image-selection-active-outline-color: #323639;

        --carousel-images-dots-gap: 24px;
        --carousel-images-dots-bottom: 0;
        --carousel-images-dots-width: 8px;
        --carousel-images-dots-height: 8px;
        --carousel-images-dots-background-color: #96989a;
        --carousel-images-dots-border-radius: 0.25rem;
        --carousel-images-dots-opacity: 1;
        --carousel-images-dots-box-shadow: none;
        --carousel-images-dots-active-width: 8px;
        --carousel-images-dots-active-height: 8px;
        --carousel-images-dots-active-background-color: #000000;
        --carousel-images-dots-active-opacity: 1;
        --carousel-images-dots-active-box-shadow: none;
    }
`;

const PorscheGlobalStyles = () => {
    useEffect(() => {
        document.documentElement.classList.add(PORSCHE_THEME_CLASSNAME);

        return () => {
            document.documentElement.classList.remove(PORSCHE_THEME_CLASSNAME);
        };
    }, []);

    return (
        <>
            <NotificationGlobalStyle />
            <FooterGlobalStyle />
            <GlobalThemeToken />
        </>
    );
};

export default PorscheGlobalStyles;
